// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//    Table,
//    Tag,
//    Typography,
//    Space,
//    Button,
//    message,
//    Select,
//    DatePicker,
//    Card,
//    Row,
//    Col,
//    Avatar,
//    Tooltip,
// } from "antd";
// import {
//    PhoneOutlined,
//    UserOutlined,
//    ClockCircleOutlined,
//    PlayCircleOutlined,
//    ReloadOutlined,
//    FilterOutlined,
//    ClearOutlined,
//    CustomerServiceOutlined,
// } from "@ant-design/icons";

// const { Text, Title } = Typography;
// const { RangePicker } = DatePicker;

// const CallLogs = () => {
//    const [logs, setLogs] = useState([]);
//    const [loading, setLoading] = useState(false);
//    const [callingId, setCallingId] = useState(null);

//    const [agent, setAgent] = useState("");
//    const [status, setStatus] = useState("");
//    const [dates, setDates] = useState([]);
//    const [agents, setAgents] = useState([]);

//    useEffect(() => {
//       fetchAgents();
//       fetchLogs();
//    }, []);

//    const fetchAgents = async () => {
//       try {
//          const res = await axios.get("http://localhost:5000/api/agents");
//          setAgents(res.data);
//       } catch (err) {
//          console.error(err);
//       }
//    };

//    const fetchLogs = async () => {
//       try {
//          setLoading(true);

//          let url = "http://localhost:5000/api/telecmi/call-logs";
//          const params = [];

//          if (agent) params.push(`agent=${agent}`);
//          if (status) params.push(`status=${status}`);

//          if (dates.length === 2) {
//             const fromDate = dates[0].format("YYYY-MM-DD");
//             const toDate = dates[1].format("YYYY-MM-DD");
//             params.push(`fromDate=${fromDate}&toDate=${toDate}`);
//          }

//          if (params.length > 0) {
//             url += "?" + params.join("&");
//          }

//          const res = await axios.get(url);
//          setLogs(res.data);
//       } catch (err) {
//          console.error(err);
//       } finally {
//          setLoading(false);
//       }
//    };

//    const handleCall = async (record) => {
//       if (!record.customer_number) {
//          message.error("Customer number missing");
//          return;
//       }

//       try {
//          setCallingId(record.id);

//          await axios.post("http://localhost:5000/api/telecmi/call", {
//             customerNumber: record.customer_number,
//             agentUserId: record.agent_user_id,
//             callerId: record.virtual_number,
//          });

//          message.success("Call initiated 📞");
//       } catch (err) {
//          message.error("Call failed");
//       } finally {
//          setCallingId(null);
//       }
//    };

//    // Format duration nicely
//    const formatDuration = (seconds) => {
//       if (!seconds || seconds === 0) return "0s";
//       const mins = Math.floor(seconds / 60);
//       const secs = seconds % 60;
//       if (mins > 0) return `${mins}m ${secs}s`;
//       return `${secs}s`;
//    };

//    const columns = [
//       {
//          title: "Customer",
//          dataIndex: "customer_number",
//          key: "customer_number",
//          render: (number) => (
//             <Space>
//                <Avatar
//                   size="small"
//                   style={{ backgroundColor: "#1890ff" }}
//                   icon={<UserOutlined />}
//                />
//                <Text strong>{number}</Text>
//             </Space>
//          ),
//       },
//       {
//          title: "Agent",
//          key: "agent",
//          render: (_, record) => {
//             const agentName =
//                record.agent_name ||
//                `Agent ${record.agent_user_id?.split("_")[0]}` ||
//                "-";

//             return (
//                <Space>
//                   <Avatar
//                      size="small"
//                      style={{ backgroundColor: "#52c41a" }}
//                      icon={<CustomerServiceOutlined />}
//                   />
//                   <Text>{agentName}</Text>
//                </Space>
//             );
//          },
//       },
//       {
//          title: "Status",
//          dataIndex: "call_status",
//          key: "call_status",
//          align: "center",
//          render: (status) => {
//             const isAnswered = status === "answered";
//             return (
//                <Tag
//                   color={isAnswered ? "success" : "error"}
//                   style={{
//                      borderRadius: 12,
//                      padding: "2px 12px",
//                      fontWeight: 500,
//                   }}
//                >
//                   {isAnswered ? "✓ Answered" : "✗ Missed"}
//                </Tag>
//             );
//          },
//       },
//       {
//          title: "Type",
//          dataIndex: "call_direction",
//          render: (dir) => (
//             <span style={{
//                color: dir === "inbound" ? "green" : "blue",
//                fontWeight: 600
//             }}>
//                {dir === "inbound" ? "📥 Incoming" : "📤 Outgoing"}
//             </span>
//          )
//       },
//       {
//          title: "Duration",
//          dataIndex: "call_duration",
//          key: "call_duration",
//          align: "center",
//          render: (duration) => (
//             <Space>
//                <ClockCircleOutlined style={{ color: "#8c8c8c" }} />
//                <Text>{formatDuration(duration)}</Text>
//             </Space>
//          ),
//       },
//       // {
//       //    title: "Recording",
//       //    dataIndex: "recording_url",
//       //    key: "recording_url",
//       //    width: 150,
//       //    render: (url, record) => {

//       //       // ⏳ Processing
//       //       if (url === "processing") {
//       //          return (
//       //             <Tag color="processing">
//       //                <ClockCircleOutlined spin /> Processing...
//       //             </Tag>
//       //          );
//       //       }

//       //       // ❌ Deleted / NULL case
//       //       if (!url || url === "deleted") {
//       //          return (
//       //             <Space direction="vertical" size={8}>
//       //                <Tag color="default">Recording expired</Tag>

//       //                <Tooltip title="Call Customer">
//       //                   <Button
//       //                      type="primary"
//       //                      size="small"
//       //                      icon={<PhoneOutlined />}
//       //                      loading={callingId === record.id}
//       //                      onClick={() => handleCall(record)}
//       //                   >
//       //                      Call
//       //                   </Button>
//       //                </Tooltip>
//       //             </Space>
//       //          );
//       //       }

//       //       // 🎧 Normal recording
//       //       const fullUrl = `http://localhost:5000${url}`;

//       //       return (
//       //          <Space direction="vertical" size={8}>
//       //             <Space>
//       //                <Tooltip title="Open Recording">
//       //                   <Button
//       //                      size="small"
//       //                      icon={<PlayCircleOutlined />}
//       //                      href={fullUrl}
//       //                      target="_blank"
//       //                   >
//       //                      Open
//       //                   </Button>
//       //                </Tooltip>

//       //                <Tooltip title="Call Customer">
//       //                   <Button
//       //                      type="primary"
//       //                      size="small"
//       //                      icon={<PhoneOutlined />}
//       //                      loading={callingId === record.id}
//       //                      onClick={() => handleCall(record)}
//       //                   >
//       //                      Call
//       //                   </Button>
//       //                </Tooltip>
//       //             </Space>
//       //          </Space>
//       //       );
//       //    },
//       // },

//       {
//          title: "Recording",
//          dataIndex: "recording_url",
//          key: "recording_url",
//          width: 150,
//          render: (url, record) => {

//             // ⏳ Processing
//             if (url === "processing") {
//                return (
//                   <Tag color="processing">
//                      <ClockCircleOutlined spin /> Processing...
//                   </Tag>
//                );
//             }

//             // ❌ Deleted
//             if (!url || url === "deleted") {
//                return (
//                   <Space direction="vertical" size={8}>
//                      <Tag color="default">Recording expired</Tag>

//                      <Button
//                         type="primary"
//                         size="small"
//                         icon={<PhoneOutlined />}
//                         loading={callingId === record.id}
//                         onClick={() => handleCall(record)}
//                      >
//                         Call
//                      </Button>
//                   </Space>
//                );
//             }

//             const fullUrl = `http://localhost:5000${url}`;

//             return (
//                <Space direction="vertical" size={8}>
//                   <Space>
//                      {/* 🎧 Open */}
//                      <Tooltip title="Open Recording">
//                         <Button
//                            size="small"
//                            icon={<PlayCircleOutlined />}
//                            href={fullUrl}
//                            target="_blank"
//                         >
//                            Open
//                         </Button>
//                      </Tooltip>

//                      {/* ⬇ Download */}
//                      <Tooltip title="Download Recording">
//                         <Button
//                            size="small"
//                            href={fullUrl}
//                            download
//                         >
//                            ⬇
//                         </Button>
//                      </Tooltip>

//                      {/* 📞 Call */}
//                      <Tooltip title="Call Customer">
//                         <Button
//                            type="primary"
//                            size="small"
//                            icon={<PhoneOutlined />}
//                            loading={callingId === record.id}
//                            onClick={() => handleCall(record)}
//                         >
//                            Call
//                         </Button>
//                      </Tooltip>
//                   </Space>
//                </Space>
//             );
//          },
//       },
//       {
//          title: "Date & Time",
//          dataIndex: "created_at",
//          width: 100,
//          key: "created_at",
//          render: (_, record) => {
//             return (
//                <Space direction="vertical" size={0}>
//                   <Text strong>{record.formatted_date}</Text>
//                   <Text type="secondary" style={{ fontSize: 12 }}>
//                      {record.formatted_time}
//                   </Text>
//                </Space>
//             );
//          }
//       },
//    ];

//    return (
//       <div style={{ padding: 24, minHeight: "100vh" }}>
//          {/* Header */}
//          <Card style={{ marginBottom: 10 }}>
//             <Row justify="space-between" align="middle">
//                <Col>
//                   <Title level={4} style={{ margin: 0 }}>
//                      <PhoneOutlined style={{ marginRight: 10, color: "#1890ff" }} />
//                      Call Logs
//                   </Title>
//                </Col>
//                <Col>
//                   <Button
//                      icon={<ReloadOutlined />}
//                      onClick={fetchLogs}
//                      loading={loading}
//                   >
//                      Refresh
//                   </Button>
//                </Col>
//             </Row>
//          </Card>

//          {/* Filters */}
//          <Card style={{ marginBottom: 16 }}>
//             <Row gutter={[16, 16]} align="middle">
//                <Col xs={24} sm={12} md={6}>
//                   <Select
//                      placeholder="Select Agent"
//                      style={{ width: "100%" }}
//                      allowClear
//                      value={agent || undefined}
//                      onChange={(val) => setAgent(val)}
//                      options={agents.map((a) => ({
//                         label: a.name,
//                         value: a.telecmi_user_id,
//                      }))}
//                      prefix={<UserOutlined />}
//                   />
//                </Col>

//                <Col xs={24} sm={12} md={5}>
//                   <Select
//                      placeholder="Status"
//                      style={{ width: "100%" }}
//                      allowClear
//                      value={status || undefined}
//                      onChange={(val) => setStatus(val)}
//                      options={[
//                         { label: "✓ Answered", value: "answered" },
//                         { label: "✗ Missed", value: "missed" },
//                      ]}
//                   />
//                </Col>

//                <Col xs={24} sm={12} md={7}>
//                   <RangePicker
//                      style={{ width: "100%" }}
//                      value={dates.length === 2 ? dates : null}
//                      onChange={(val) => setDates(val || [])}
//                      format="DD/MM/YYYY"
//                   />
//                </Col>

//                <Col xs={24} sm={12} md={6}>
//                   <Space>
//                      <Button
//                         type="primary"
//                         icon={<FilterOutlined />}
//                         onClick={fetchLogs}
//                      >
//                         Apply
//                      </Button>

//                      <Button
//                         icon={<ClearOutlined />}
//                         onClick={() => {
//                            setAgent("");
//                            setStatus("");
//                            setDates([]);
//                            fetchLogs();
//                         }}
//                      >
//                         Reset
//                      </Button>
//                   </Space>
//                </Col>
//             </Row>
//          </Card>

//          {/* Table */}
//          <Card>
//             <Table
//                columns={columns}
//                dataSource={logs}
//                rowKey="id"
//                loading={loading}
//                pagination={{
//                   pageSize: 10,
//                   showSizeChanger: true,
//                   showTotal: (total) => `Total ${total} calls`,
//                }}
//                style={{ overflowX: "auto" }}
//                size="small"

//             />
//          </Card>
//       </div>
//    );
// };

// export default CallLogs;

import { useEffect, useState } from "react";
import {
   Table,
   Tag,
   Typography,
   Space,
   Button,
   message,
   Select,
   DatePicker,
   Card,
   Row,
   Col,
   Avatar,
   Tooltip,
} from "antd";
import {
   PhoneOutlined,
   UserOutlined,
   ClockCircleOutlined,
   PlayCircleOutlined,
   ReloadOutlined,
   FilterOutlined,
   ClearOutlined,
   CustomerServiceOutlined,
} from "@ant-design/icons";

import {
   fetchAgentsAPI,
   fetchLogsAPI,
   makeCallAPI
} from "../../services/callLogs";

const { Text, Title } = Typography;
const { RangePicker } = DatePicker;

const CallLogs = () => {
   const [logs, setLogs] = useState([]);
   const [loading, setLoading] = useState(false);
   const [callingId, setCallingId] = useState(null);

   const [agent, setAgent] = useState("");
   const [status, setStatus] = useState("");
   const [dates, setDates] = useState([]);
   const [agents, setAgents] = useState([]);

   useEffect(() => {
      fetchAgents();
      fetchLogs();
   }, []);

   const fetchAgents = async () => {
      try {
         const res = await fetchAgentsAPI();
         setAgents(res.data);
      } catch (err) {
         console.error(err);
      }
   };

   const fetchLogs = async () => {
      try {
         setLoading(true);

         const res = await fetchLogsAPI({
            agent,
            status,
            dates
         });

         setLogs(Array.isArray(res.data) ? res.data : []);;
      } catch (err) {
         console.error(err);
      } finally {
         setLoading(false);
      }
   };

   const handleCall = async (record) => {
      if (!record.customer_number) {
         message.error("Customer number missing");
         return;
      }

      try {
         setCallingId(record.id);

         await makeCallAPI({
            customerNumber: record.customer_number,
            agentUserId: record.agent_user_id,
            callerId: record.virtual_number,
         });

         message.success("Call initiated 📞");
      } catch (err) {
         message.error("Call failed");
      } finally {
         setCallingId(null);
      }
   };

   const formatDuration = (seconds) => {
      if (!seconds || seconds === 0) return "0s";
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      if (mins > 0) return `${mins}m ${secs}s`;
      return `${secs}s`;
   };

   // const getFullUrl = (url) => {
   //    if (!url || typeof url !== "string") return "";

   //    if (url.startsWith("http")) return url;

   //    const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
   //    const cleanBase = base.replace("/api", "");

   //    return `${cleanBase}${url}`;
   // };

   const getFullUrl = (url) => {
      if (!url || typeof url !== "string") return "";

      if (url.startsWith("http")) return url;

      const base = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

      const cleanBase = base.replace(/\/api\/?$/, ""); // remove /api or /api/
      const cleanUrl = url.startsWith("/") ? url : `/${url}`;

      return `${cleanBase}${cleanUrl}`;
   };

   const columns = [
      {
         title: "Customer",
         dataIndex: "customer_number",
         key: "customer_number",
         render: (number) => (
            <Space>
               <Avatar
                  size="small"
                  style={{ backgroundColor: "#1890ff" }}
                  icon={<UserOutlined />}
               />
               <Text strong>{number}</Text>
            </Space>
         ),
      },
      {
         title: "Agent",
         key: "agent",
         render: (_, record) => {
            const agentName =
               record.agent_name ||
               (record.agent_user_id ? `Agent ${record.agent_user_id.split("_")[0]}` : "-");

            return (
               <Space>
                  <Avatar
                     size="small"
                     style={{ backgroundColor: "#52c41a" }}
                     icon={<CustomerServiceOutlined />}
                  />
                  <Text>{agentName}</Text>
               </Space>
            );
         },
      },
      {
         title: "Status",
         dataIndex: "call_status",
         key: "call_status",
         align: "center",
         render: (status) => {
            const isAnswered = status === "answered";
            return (
               <Tag
                  color={isAnswered ? "success" : "error"}
                  style={{
                     borderRadius: 12,
                     padding: "2px 12px",
                     fontWeight: 500,
                  }}
               >
                  {isAnswered ? "✓ Answered" : "✗ Missed"}
               </Tag>
            );
         },
      },
      {
         title: "Type",
         dataIndex: "call_direction",
         render: (dir) => (
            <span style={{
               color: dir === "inbound" ? "green" : "blue",
               fontWeight: 600
            }}>
               {dir === "inbound" ? "📥 Incoming" : "📤 Outgoing"}
            </span>
         )
      },
      {
         title: "Duration",
         dataIndex: "call_duration",
         key: "call_duration",
         align: "center",
         render: (duration) => (
            <Space>
               <ClockCircleOutlined style={{ color: "#8c8c8c" }} />
               <Text>{formatDuration(duration)}</Text>
            </Space>
         ),
      },
      {
         title: "Recording",
         dataIndex: "recording_url",
         key: "recording_url",
         width: 150,
         render: (url, record) => {

            if (url === "processing") {
               return (
                  <Tag color="processing">
                     <ClockCircleOutlined spin /> Processing...
                  </Tag>
               );
            }

            if (!url || url === "deleted") {
               return (
                  <Space direction="vertical" size={8}>
                     <Tag color="default">Recording expired</Tag>

                     <Button
                        type="primary"
                        size="small"
                        icon={<PhoneOutlined />}
                        loading={callingId === record.id}
                        onClick={() => handleCall(record)}
                     >
                        Call
                     </Button>
                  </Space>
               );
            }

            const fullUrl = getFullUrl(url);

            return (
               <Space direction="vertical" size={8}>
                  <Space>
                     <Tooltip title="Open Recording">
                        <Button
                           size="small"
                           icon={<PlayCircleOutlined />}
                           href={fullUrl}
                           target="_blank"
                        >
                           Open
                        </Button>
                     </Tooltip>

                     {/* <Tooltip title="Download Recording">
                        <Button
                           size="small"
                           href={fullUrl}
                           download
                        >
                           ⬇
                        </Button>
                     </Tooltip> */}

                     <Tooltip title="Call Customer">
                        <Button
                           type="primary"
                           size="small"
                           icon={<PhoneOutlined />}
                           loading={callingId === record.id}
                           onClick={() => handleCall(record)}
                        >
                           Call
                        </Button>
                     </Tooltip>
                  </Space>
               </Space>
            );
         },
      },
      {
         title: "Date & Time",
         dataIndex: "created_at",
         width: 100,
         key: "created_at",
         render: (_, record) => {
            return (
               <Space direction="vertical" size={0}>
                  <Text strong>{record.formatted_date}</Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                     {record.formatted_time}
                  </Text>
               </Space>
            );
         }
      },
   ];

   return (
      <div style={{ padding: 24, minHeight: "100vh" }}>
         <Card style={{ marginBottom: 10 }}>
            <Row justify="space-between" align="middle">
               <Col>
                  <Title level={4} style={{ margin: 0 }}>
                     <PhoneOutlined style={{ marginRight: 10, color: "#1890ff" }} />
                     Call Logs
                  </Title>
               </Col>
               <Col>
                  <Button
                     icon={<ReloadOutlined />}
                     onClick={fetchLogs}
                     loading={loading}
                  >
                     Refresh
                  </Button>
               </Col>
            </Row>
         </Card>

         <Card style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]} align="middle">
               <Col xs={24} sm={12} md={6}>
                  <Select
                     placeholder="Select Agent"
                     style={{ width: "100%" }}
                     allowClear
                     value={agent || undefined}
                     onChange={(val) => setAgent(val)}
                     options={(agents || []).map((a) => ({
                        label: a.name,
                        value: a.telecmi_user_id,
                     }))}
                  />
               </Col>

               <Col xs={24} sm={12} md={5}>
                  <Select
                     placeholder="Status"
                     style={{ width: "100%" }}
                     allowClear
                     value={status || undefined}
                     onChange={(val) => setStatus(val)}
                     options={[
                        { label: "✓ Answered", value: "answered" },
                        { label: "✗ Missed", value: "missed" },
                     ]}
                  />
               </Col>

               <Col xs={24} sm={12} md={7}>
                  <RangePicker
                     style={{ width: "100%" }}
                     value={dates.length === 2 ? dates : null}
                     onChange={(val) => setDates(val || [])}
                     format="DD/MM/YYYY"
                  />
               </Col>

               <Col xs={24} sm={12} md={6}>
                  <Space>
                     <Button type="primary" onClick={fetchLogs}>
                        Apply
                     </Button>

                     <Button
                        onClick={() => {
                           setAgent("");
                           setStatus("");
                           setDates([]);
                           fetchLogs();
                        }}
                     >
                        Reset
                     </Button>
                  </Space>
               </Col>
            </Row>
         </Card>

         <Card>
            <Table
               columns={columns}
               dataSource={logs}
               rowKey="id"
               loading={loading}
               pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `Total ${total} calls`,
               }}
               style={{ overflowX: "auto" }}
               size="small"
            />
         </Card>
      </div>
   );
};

export default CallLogs;